// src/routes/ResetPasswordWrapper.jsx
import React, { useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ResetPassword from "./ResetPassword"; // your MUI + RHF component

export default function ResetPasswordWrapper() {
    const location = useLocation();
    const navigate = useNavigate();

    const urlParams = new URLSearchParams(location.search);
    const urlToken = urlParams.get("token") || null;

    // preferred: token passed via navigation state
    const navToken = location.state?.resetToken ?? null;
    const email = location.state?.email ?? '';

    // fallback: localStorage (survives refresh in same tab)
    const storedToken = typeof window !== "undefined" ? sessionStorage.getItem("reset-token") : null;

    // token resolved
    const token = navToken || storedToken || urlToken || null;


    if ((navToken || urlToken) && !storedToken) {
        try {
            sessionStorage.setItem("reset-token", navToken);
        } catch (e) {
            // console.warn("session  not available", e);
        }
    }

    // Render the reset page and give it the token + a callback to clear storage on success
    return (
        <ResetPassword
            token={token}
            email={email}
            onResetSuccess={() => {
                // clear fallback on successful reset
                try {
                    sessionStorage.removeItem("reset-token");
                } catch (e) {}
                // send to signin after reset (ResetPassword may also do this)
                navigate("/smartmoney/signin", { replace: true });
            }}
        />
    );
}
